import {
  SET_ROUND,
  UPDATE_FEEDBACK,
  UPDATE_POLICY_CHOICE_OPTIONS
} from '../actions/types';

const initialState = [];
let round = -1;
let data = [];

const policyChoice = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case UPDATE_FEEDBACK:
      if(round===-1) {
        round = payload.length - 1;
      }
      break;
    case UPDATE_POLICY_CHOICE_OPTIONS:
      data = payload;
      break;
    case SET_ROUND:
      round = payload;
      break;
    default:
      return state;
  }
  if (Array.isArray(data)) {
    if(!data.length) return [];
    return data[round === -1 ? data.length-1 : round] || [];
  } else if (typeof data === 'object') {
    return data[round === -1 ? Object.keys(data).length-1 : round] || [];
  }
  return [];
};

export default policyChoice;



// WEBPACK FOOTER //
// ./src/reducers/policyChoice.js